import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisUiService } from '../../core/service/base/his-ui.service';
import { HisEnumUtils } from '../../core/utils';
import { HisOperatorTrigger } from '../model/his-operator-trigger';
import { HisSelectOperatorType } from '../model/his-select-operator-type';
import { HisWidgetBaseSelect } from '../model/his-widget-base-select';
import { HisSearchService } from '../service/his-search.service';

@Component( {
    selector: 'his-search-select-operator',
    templateUrl: './his-search-select-operator.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisSearchSelectOperatorComponent implements OnInit, AfterViewInit {
    private searchService = inject(HisSearchService);
    private hisUiService = inject(HisUiService);


    @Input() widget: HisWidgetBaseSelect<any>;

    @Input() isFirstInputElement = false;
    @ViewChild( 'inputElement' ) inputElement: ElementRef;

    tooltip: string;

    selectedOperator: string;
    currentOperators: string[] = [];

    private operators: string[] = HisEnumUtils.getValues( HisSelectOperatorType );

    ngOnInit(): void {
        // console.log('his-search-select-operator#ngOnInit() #tooltip', this.tooltip);

        this.initializeResetInputs();
        this.setResetInputs( false );
        this.initializeSelectOperator();
        console.log( 'his-search-select-operator#ngOnInit() #this.widget.not', this.widget.not );

        /* Falls "Suche ändern" und unequal im Suchformular ausgewählt war */
        if ( this.widget.not ) {
            this.selectedOperator = HisSelectOperatorType.UNEQUAL;
            this.tooltip = this.hisUiService.translate( 'genericSearch.operator.notequal' );
        } else {
            this.selectedOperator = HisSelectOperatorType.EQUAL;
            this.tooltip = this.hisUiService.translate( 'genericSearch.operator.equal' );
        }
    }

    ngAfterViewInit() {
        // Set focus on first input element
        if ( this.isFirstInputElement ) {
            setTimeout( () => this.inputElement?.nativeElement?.focus() );
        }
    }

    selectOperator() {
        if ( this.selectedOperator === HisSelectOperatorType.UNEQUAL ) {
            this.widget.not = true;
            this.tooltip = this.hisUiService.translate( 'genericSearch.operator.notequal' );
            return;
        }
        this.tooltip = this.hisUiService.translate( 'genericSearch.operator.equal' );
        this.widget.not = false;
    }

    completeMethod( $event: { query: string } ) {
        this.currentOperators = []; // ohne Neu-Initialisierung funktioniert es nicht
        for ( let operator of this.operators ) {
            this.currentOperators.push( operator );
        }
    }

    /* Wenn der Button 'Eingaben zurücksetzen' gedrückt wird,
     * muss das Auswahlfeld für Suchsets die leere Option anzeigen*/
    initializeResetInputs() {
        this.searchService.resetInputs.subscribe( ( resetInputs: boolean ) => {
            if ( resetInputs ) {
                if ( this.widget ) {
                    this.widget.not = false;
                }
                this.selectedOperator = HisSelectOperatorType.EQUAL;
            }
        } );
    }

    initializeSelectOperator() {
        this.searchService.selectOperator.subscribe( ( operatorTrigger: HisOperatorTrigger ) => {

            if ( operatorTrigger === undefined ) {
                return;
            }

            let trigger = operatorTrigger as HisOperatorTrigger;

            if ( trigger.getWidget().kind !== this.widget.kind ) {
                return;
            }

            if ( trigger.getWidget().id !== this.widget.id ) {
                return;
            }

            if ( trigger.getOperator() === HisSelectOperatorType.UNEQUAL ) {
                this.widget.not = true;
                this.selectedOperator = HisSelectOperatorType.UNEQUAL;
                return;
            }

            if ( trigger.getOperator() === HisSelectOperatorType.EQUAL ) {
                this.widget.not = false;
                this.selectedOperator = HisSelectOperatorType.EQUAL;
                return;
            }
        } );
    }

    setResetInputs( resetInputs: boolean ) {
        this.searchService.setResetInputs( resetInputs );
    }
}
